import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageLoadMarkFMP } from '../Bm3PageLoadMarkFMP.tsx';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

/**
 * Interop component that renders either null (under UFO, since FMP marks
 * are handled natively) or the legacy Bm3PageLoadMarkFMP (which creates BM3
 * FMP marks) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageLoadMarkFMP = (props: PageLoadMarkFMPProps) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return null;
	}

	return <Bm3PageLoadMarkFMP {...props} />;
};
